import React from "react";
import { Container, Row, Col, Table } from "react-bootstrap";

const Services = () => {
  // Заглушка: потом заменишь это на данные из Excel
  const montazhiData1 = [
  { name: "Монтаж 05-10", prices: [6990, 7990, 8990, 10990] },
  { name: "Монтаж 11-13", prices: [7490, 8490, 9990, 11990] },
  { name: "Монтаж 14-18", prices: [7990, 8990, 10990, 13990] },
  { name: "Монтаж 19-24", prices: [8990, 10490, 11990, 15990] },
  { name: "Монтаж 25-28", prices: [9490, 10990, 12990, 16990] },
  { name: "Монтаж 29-36", prices: [10990, 11990, 14490, 17990] },
  { name: "Выезд инженера для замера и просчёта монтажа", prices: [1500, 1500, 1500, 1500] },
  { name: "Материал труб", prices: ["Медь", "Медь", "Медь", "Медь"] },
  { name: "Длинна магитстрали, max, м", prices: [1, 2, 3, 3] },
  { name: "Дополнительная магистраль 05-10, м", prices: [1500, 1500, 1500, 1500] },
  { name: "Дополнительная магистраль 11-13, м", prices: [1700, 1700, 1700, 1700] },
  { name: "Дополнительная магистраль 14-18, м", prices: [1800, 1800, 1800, 1800] },
  { name: "Дополнительная магистраль 19-24, м", prices: [2000, 2000, 2000, 2000] },
  { name: "Дополнительная магистраль 25-28, м", prices: [2200, 2200, 2200, 2200] },
  { name: "Дополнительная магистраль 29-36, м", prices: [2500, 2500, 2500, 2500] },
  { name: "Дополнительный дренаж, м", prices: [350, 350, 350, 350] },
  { name: "Монтаж с использованием лестницы (1 этаж)", prices: [500, 500, "Бесплатно", "Бесплатно"] },
  { name: "Монтаж с использованием лестницы (2 этаж)", prices: [1500, 1500, 1500, "Бесплатно"] },
  { name: "Использование не стандартных креплений / дюбелей", prices: ["от 500", "от 500", "от 500", "от 500"] },
  { name: "Работа с сайдингом, фасадом, утеплителем", prices: ["от 1200", "от 1200", "от 1200", "от 1200"] },
  { name: "Снятие/установка пластикового стеклопакета до 20 кг", prices: ["от 1000", "от 1000", "от 1000", "Бесплатно"] },
  { name: "Снятие/установка пластикового стеклопакета более 20 кг", prices: ["от 1500", "от 1500", "от 1500", "от 1500"] },
  { name: "Демонтаж сплит-системы 05-18", prices: [3000, 3000, 3000, 3000] },
  { name: "Демонтаж сплит-системы 19-36", prices: [4000, 4000, 4000, 4000] },
  { name: "Демонтаж внутреннего блока", prices: [2000, 2000, 2000, 2000] },
  { name: "Демонтаж наружнего блока", prices: [2000, 2000, 2000, 2000] },
  { name: "Установка за боковой край окна (без балкона)", prices: [700, 700, "Бесплатно", "Бесплатно"] },
  { name: "Установка усиленного кронштейна 500х600 (2,5 мм)", prices: [2000, 2000, 2000, 2000] },
  { name: "Установка декоративного короба 60х40 за 1 метр", prices: [700, 700, 700, 700] },
  { name: "Монтаж с использованием строительного пылесоса", prices: [1000, 1000, 1000, "Бесплатно"] },
  { name: "Срочный монтаж (за 24 часа), доплата", prices: [3000, 3000, 3000, 3000] },
  { name: "Установка сетевой вилки, если не в комплекте", prices: [300, 300, "Бесплатно", "Бесплатно"] },
  { name: "Доработка внешней розетки (1 точка)", prices: [800, 800, 800, 800] },
  { name: "Прокладка провода + к/канала, м", prices: [800, 800, 800, 800] },
  { name: "Бурение отверстия 32–45 мм", prices: [500, 500, 500, "2 бесплатно, 3-е и после 500"] },
  { name: "Бурение отверстия 46–60 мм", prices: [1000, 1000, 1000, 1000] },
  { name: "Алмазное бурение (сухое) 40–45 мм", prices: [1500, 1500, 1500, "Бесплатно"] },
  { name: "Использование траверсы при установке наружного блока", prices: [1000, 1000, 1000, 1000] },
  { name: "Установка козырька", prices: [1500, 1500, 800, 800] },
  { name: "Монтаж / демонтаж антивандальной решётки", prices: [2000, 2000, 1000, 1000] },
  { name: "Установка помпы", prices: [2000, 2000, 2000, 2000] },
  { name: "Установка зимнего комплекта", prices: [2500, 2500, 2500, 2500] },
  { name: "Дополнительный / ложный выезд монтажной бригады", prices: [1200, 1200, 1200, 1200] },
  { name: "Выезд за черту города (за 1 км)", prices: [30, 30, 30, 30] },
  { name: "Установка блока подмеса свежего воздуха Q2-fresh", prices: [3000, 3000, 3000, 3000] },
  { name: "Разборка/сборка потолка армстронг за 1 м²", prices: [100, 100, 100, 100] },
  { name: "Работа с керамзитом при бурении", prices: [1500, 1500, 1500, 1500] }
];

const montazhiData2 = [
  { name: "Закладка трассы 05-10 (1 метр)", price: 1500 },
  { name: "Закладка трассы 11-13 (1 метр)", price: 1700 },
  { name: "Закладка трассы 14-18 (1 метр)", price: 1800 },
  { name: "Закладка трассы 19-24 (1 метр)", price: 2000 },
  { name: "Штроба под межблочную трассу", price: 1000 },
  { name: "Навес внутреннего блока 5-15", price: 3000 },
  { name: "Навес внутреннего блока 17-18", price: 3500 },
  { name: "Навес внутреннего блока 24", price: 4000 },
  { name: "Навес наружного блока 5-15", price: 3000 },
  { name: "Навес наружного блока 17-18", price: 3500 },
  { name: "Навес наружного блока 24", price: 4000 }
];
const montazhiData3 = [
  { name: "ТО (чистка) внутреннего и внешнего блока 05-18", price: 2500 },
  { name: "ТО (чистка) внутреннего и внешнего блока 18-36", price: 3000 },
  { name: "Антибактериальная обработка / моющие средства", price: "Бесплатно" },
  { name: "Выезд в порядке очереди", price: "Да" },
  { name: "Срочный выезд (за 24 часа), доплата", price: 1000 },
  { name: "Заправка фреоном R410, руб/г", price: 6 },
  { name: "Заправка фреоном R22, руб/г", price: 10 },
  { name: "Заправка фреоном R32, руб/г", price: 6 }
];
const montazhiData4 = [
  { name: "Диагностика сплит-системы", price: 1000 },
  { name: "Выезд в порядке очереди", price: "Да" },
  { name: "Срочный выезд (за 24 часа), доплата", price: 800 },
  { name: "Ремонт электросхемы (on/off) сплит-системы", price: "от 2000" },
  { name: "Ремонт электросхемы (inverter) сплит-системы", price: "от 2500" },
  { name: "Замена пускового конденсатора сплит-системы", price: "от 5000" },
  { name: "Устранение утечки фреона (пайка) сплит системы", price: "от 1600" },
  { name: "Перевальцовка (1 стык)", price: 350 },
  { name: "Замена компрессора без заправки сплит системы", price: "от 5000" }
];

  const priceCategories = ["Эконом", "Эконом+", "Стандарт", "Премиум"];

  return (
    <Container className="my-5">
      <h1 className="mb-4">Наши услуги</h1>

      <p className="lead">
        Мы занимаемся продажей, установкой и обслуживанием сплит-систем, кондиционеров и другого климатического оборудования.
        Работаем по стандартам качества, соблюдаем сроки и гарантируем аккуратный монтаж.
      </p>

      <p>
        Почему выбирают нас:
        <ul>
          <li>Опыт более 10 лет в установке климатического оборудования</li>
          <li>Только проверенные мастера с профильной квалификацией</li>
          <li>Гарантия на все виды работ</li>
          <li>Прозрачные цены — всё уже включено, никаких скрытых платежей</li>
        {/* <li>Выезд в день обращения и монтаж в удобное для вас время</li> */}  
        </ul>
      </p>

      {/* Секция 1 — Монтажи бытовые */}
      <Row className="mt-5">
        <Col>
          <h2 className="mb-3">Монтажи бытовые</h2>
          <Table striped bordered hover responsive>
            <thead>
              <tr>                
                <th>Услуга</th>
                {priceCategories.map((cat) => (
                  <th key={cat}>{cat}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {montazhiData1.map((item) => (
                <tr key={item.name}>
                  <td>{item.name}</td>
                  {item.prices.map((price, idx) => (
                    <td key={idx}>{price}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </Table>
        </Col>
      </Row>

      {/* Секция 2 и далее — просто дублируешь блок Row + Table под другие листы */}
       <Row className="mt-5">
        <Col>
          <h2 className="mb-3">Монтаж в в 2 этапа</h2>
          <Table striped bordered hover responsive>
            <thead>
              <tr>                
                <th>Услуга</th>
                <th>Стоимость</th>
              </tr>
            </thead>
            <tbody>
              {montazhiData2.map((item) => (
                <tr key={item.name}>
                  <td>{item.name}</td>
                  <td>{item.price}</td>     
                </tr>
              ))}
            </tbody>
          </Table>
        </Col>
      </Row>

       <Row className="mt-5">
        <Col>
          <h2 className="mb-3">Стоимость технического обслуживания</h2>
          <Table striped bordered hover responsive>
            <thead>
              <tr>                
                <th>Услуга</th>
                <th>Стоимость</th>               
              </tr>
            </thead>
            <tbody>
              {montazhiData3.map((item) => (
                <tr key={item.name}>
                  <td>{item.name}</td>
                  <td>{item.price}</td>                  
                </tr>
              ))}
            </tbody>
          </Table>
        </Col>
      </Row>
             <Row className="mt-5">
        <Col>
          <h2 className="mb-3">Стоимость ремонтных работ</h2>
          <Table striped bordered hover responsive>
            <thead>
              <tr>                
                <th>Услуга</th>
                <th>Стоимость</th>               
              </tr>
            </thead>
            <tbody>
              {montazhiData4.map((item) => (
                <tr key={item.name}>
                  <td>{item.name}</td>
                  <td>{item.price}</td>                  
                </tr>
              ))}
            </tbody>
          </Table>
        </Col>
      </Row>

    </Container>
  );
};

export default Services;